import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  EMAIL_VALIDATION,
  loginRedirection,
  PASSWORD_VALIDATION,
  CONFIRM_PASSWORD_VALIDATION,
  SWIT_SUCCESS,
  TOAST_ERROR,
} from "../../utils/common.service";
import * as API from "../../utils/api.service";
import { Helmet } from "react-helmet";
import AuthLogoAndImage from "../../component/AuthLogoAndImage";
import { setLoader } from "../../Store/slices/MasterSlice";
import { useDispatch } from "react-redux";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";

const ForgotPasswordEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));
      let requestBody = {
        password: submitData?.password,
        token: token,
      };
      const { code, message } = await await API.forgotPasswordChange(
        requestBody
      );
      if (code === "1") {
        SWIT_SUCCESS(message);
        navigate("/");
        reset();
      }
      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <Helmet>
        <body className="authentication-bg position-relative"></body>
      </Helmet>
      <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5 position-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-lg-10">
              <div className="card overflow-hidden">
                <AuthLogoAndImage>
                  <div className="p-4 my-auto">
                    <h4 className="fs-20">Change Password?</h4>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            className="form-control"
                            type={showPassword ? "text" : "password"}
                            id="password"
                            placeholder="Enter your password"
                            {...register("password", PASSWORD_VALIDATION())}
                            aria-invalid={errors.password ? "true" : "false"}
                          />
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Icon
                              icon={showPassword ? eye : eyeOff}
                              size={20}
                            />
                          </span>
                        </div>
                        <label className="errorc">
                          {errors.password?.message}
                        </label>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="con_password" className="form-label">
                          Confirm Password
                        </label>
                        <div className="position-relative">
                          <input
                            className="form-control"
                            type={showConfirmPassword ? "text" : "password"}
                            id="con_password"
                            placeholder="Enter password again"
                            {...register(
                              "con_password",
                              CONFIRM_PASSWORD_VALIDATION(watch("password"))
                            )}
                            aria-invalid={
                              errors.con_password ? "true" : "false"
                            }
                          />
                          <span
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Icon
                              icon={showConfirmPassword ? eye : eyeOff}
                              size={20}
                            />
                          </span>
                        </div>
                        <label className="errorc">
                          {errors.con_password?.message}
                        </label>
                      </div>

                      <div className="mb-0 text-start">
                        <button
                          className="btn btn-soft-primary w-100 buttonColor"
                          type="submit"
                        >
                          <i className="ri-loop-left-line me-1 fw-bold"></i>{" "}
                          <span className="fw-bold">Reset Password</span>{" "}
                        </button>
                      </div>
                    </form>
                  </div>
                </AuthLogoAndImage>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <p className="text-dark-emphasis">
                Back To
                <Link
                  to="/login"
                  className="text-dark fw-bold ms-1 link-offset-3 text-decoration-underline"
                >
                  <b>Log In</b>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordEmail;
